export class verifyDocument {
    firstname: String;
	lastname: String;
	streamid: String;
	docname: String;
	enrollno :String;
	yearofpassid :String;
	collegenameid :String;
	uniid :String = "";
	userid :String = localStorage.getItem('user_id');
	// requesttypeid :String = "";
	uploaddocpath :String = "";
}